import { getItem } from 'utils/localStorage';

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/dist/locale-data/en');
}

const enTranslationMessages = require('./translations/en.json');
const srTranslationMessages = require('./translations/sr.json');
const chTranslationMessages = require('./translations/ch.json');

const DEFAULT_LOCALE = getItem('language') || 'sr';

// prettier-ignore
const appLocales = [
  'en',
  'sr',
  'ch'
];

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, srTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  sr: formatTranslationMessages('sr', srTranslationMessages),
  ch: formatTranslationMessages('ch', chTranslationMessages)
};

export {
  appLocales,
  formatTranslationMessages,
  translationMessages,
  DEFAULT_LOCALE
};
